function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 192 192"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M41.733 160.134v-59.2H21.999L96 31.865l74 69.067h-19.733v59.201H110.8v-44.4H81.2v44.4z",
  style: {
    fill: "none",
    fillOpacity: 1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5,
    strokeDasharray: "none",
    strokeOpacity: 1
  }
}));
export default SvgHouse;